





























import Vue from "vue";

// Vue components
import MachineStatusPropsList from "@/components/PropsLists/MachineStatusPropsList.vue";
import DiagnosticImageCard from "@/views/App/Components/DiagnosticImageCard.vue";
import InstalledSoftwaresTable from "@/views/App/ServiceAndUpdates/UpdatesManagement/DetailsSection/InstalledSoftwaresTable.vue";

// Model

export default Vue.extend({
    components: {
        MachineStatusPropsList,
        DiagnosticImageCard,
        InstalledSoftwaresTable,
    },
    props: ["machine", "machineStatus", "machineUpdate", "hideStatus", "hasAgent"],
});
